<template>
  <div class="form-control">
    <label class="block" :class="[themes_labes[theme]]" :for="name" v-if="label">
      <span v-html="label"></span>
      <span v-if="required" class="obligatoire">*</span>
    </label>
    <list-select
      :list="options"
      option-value="value"
      option-text="name"
      :placeholder="placeholder"
      :selected-item="item"
      @select="onSelect"
      autocomplete="new-password"
      :name="name"
      :id="id"
      :isDisabled="disabled"
    ></list-select>
  </div>
</template>

<style>
.ui.selection.dropdown {
    border: 1px solid #7d8593 !important;
    border-radius: 5px !important;
    color: #313232 !important;
    line-height: 1.2;
    font-size: 16px;
}
.ui.fluid.dropdown > .dropdown.icon {
    top: 1.3rem !important;
}
.ui.selection.active.dropdown .menu {
    border-color: #7d8593 !important;
}
</style>

<script>
import { ListSelect } from "vue-search-select";

export default {
  name: "sp-select",
  components: {
    ListSelect
  },
  props: {
    label: String,
    placeholder: String,
     disabled: {
      type: Boolean,
      default: false
    },
    name: {
      required: false,
      type: String
    },
    id: {
      required: false,
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    modelValue: {
      default: undefined
    },
    theme: {
      required: false,
      type: String,
      default: ""
    },
    monospaced: {
      type: Boolean,
      default: false
    },
    hasError: {
      required: false,
      type: Boolean,
      default: false
    },
    options: {
      type: Object | Array,
      required: false,
      default: function () {
          return []
      }
    },
    selected: {
      type: String | Array,
      default: null
    },
    change_options: {
        type: Object | Array,
        required: false,
        default: function () {
            return []
        }
    },
  },
  data() {
    return {
      themes: {
        default: "",
        form:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        team:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        "team-i":
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight pl-14"
      },
      themes_labes: {
        default: "mb-4",
        form: "text-blue text-2sm mb-4",
        team: "text-blue text-2sm font-bold mb-3",
        "team-i": "text-blue text-2sm font-bold mb-3"
      },
      item: {
        name: "",
        value: ""
      },
    };
  },
  mounted() {
    if (this.selected) {

      let op = this.options.find(this.findValue);
      this.item = op;
    }

    // Set input autocomplete attribute to `new-password` 
    let inputSelect = document.getElementsByName(this.name);
    for(let i=0; i< inputSelect.length ; i++){
       inputSelect[i].setAttribute("autocomplete", "new-password");
    }
  },
  methods: {
    findValue(op) {
      if (op.name == this.selected) {
        return op;
      }
    },
    onSelect(item) {
      this.item = item;
      this.toggle();
      this.$emit('option-selected', item.identif);
    },
    // deselect option
    reset() {
      this.item = {}; // reset
    },
    onChange() {
      this.toggle();
    },
    toggle() {
      this.$emit("input", this.item.name);
      this.$emit("select-team", this.item);
      const selectedInnerData = (this.options.filter(e => e.name == this.item.name))[0]
      if(selectedInnerData){
        this.$emit("inner-data", selectedInnerData)
      }
    }
  }, 
  watch:{
    selected(val){
      if (val == null){
        this.reset();
      } 
      else{
        let op = this.options.find(this.findValue);
        this.item = op;
      }
    },
    change_options(val){
        if (val != null){
            let newOptions = [];
            for(let i = 0; i< (val).length; i++){
              for(let j = 0; j< (this.options).length; j++){
                if((val)[i].name == (this.options)[j].name){
                  newOptions.push((this.options)[j])
                  break
                }
              }
            }
            this.options = newOptions;
        }
    }
  }
};
</script>

<style>
</style>
